// @flow
import { always } from "ramda"
import { isValid } from "date-fns"

import { departureArrivalFromJS, _getDuration } from "../Flight/utils"
import type { Transfer } from "./Transfer"

export const getDuration = (transfer: Transfer) => {
  const { arrival, departure } = transfer
  if (!arrival || !departure) {
    return null
  }
  // Ugly fix when utc time format not available
  const timeFormat = !isValid(arrival.when.utc) ? "local" : "utc"

  return _getDuration(arrival.when[timeFormat], departure.when[timeFormat])
}

export const getFlightNumber: Transfer => null = always(null)

export const hasDifferentOperatingAirline: Transfer => false = always(false)

export const convertFromApi = (input: any): Transfer => ({
  pnr: null,
  operatingAirline: null,
  id: input.id,
  departure: departureArrivalFromJS(input.departure),
  arrival: departureArrivalFromJS(input.arrival),
  vehicle: input.vehicle,
  carrier: input.carrier,
  flightIndex: input.flightIndex,
  type: input.type,
  fareCategory: null,
})
